import React from 'react'
import useStyles from './ReportsTab.styles'
import {Tab} from '@material-ui/core'
import {useReportsTabContext} from './ReportsTab.context'

export type ReportsTabExtensionProps = {}

type Props = ReportsTabExtensionProps & {
  label: string
  children: React.ReactNode
  'data-testid': string
}

function ReportsTab(props: Props) {
  const {children, ...rest} = props
  const classes = useStyles()
  const {setRenderer, count} = useReportsTabContext()

  const width = `${100.0 / count}%`

  setRenderer((rest as any).value, () => children)

  return (
    <Tab className={classes.root} data-testid={props['data-testid']} style={{width}} {...rest} />
  )
}

export default ReportsTab
